<template>
  <div
    class="rounded-xl px-5 py-6 md:p-10 space-y-6"
    :style="{
      backgroundColor: mainColor,
    }"
  >
    <div class="flex flex-wrap gap-3 pt-1 sm:gap-6">
      <img
        loading="lazy"
        :src="showcase?.form_logo?.url || '/showcases/form-logo.svg'"
        class="max-h-[45px] object-contain"
      />
      <img
        loading="lazy"
        :src="showcase?.form_slogan?.url || '/showcases/form-slogan.svg'"
        class="max-h-[45px] object-contain"
      />
    </div>
    <div class="text-white font-extrabold text-[22px] md:text-[34px]">
      {{ showcase?.form_title || 'DEVELOPER SHOWCASE' }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { useShowcases } from '~/stores/showcases'

const { showcase, mainColor } = storeToRefs(useShowcases())
</script>
